import React, { useState, useEffect } from "react";
import * as Icons from "react-feather";
import { useList } from "store/list";
import { useCore } from "store/core";
import Loading from "components/Loading";
import ListSearch from "components/list/ListSearch";
import ListPagination from "components/list/ListPagination";
import Add from "./Add";
import Edit from "./Edit";
import Delete from "./Delete";
import { handleSuccessMessages } from "store/auth";
import { toJalali } from "lib/helpers";
import ListFilter from "components/list/ListFilter";
import config from "config";
import { getCategories } from "store/core";
import { getTags } from "store/core";
import transformDataToDropdownFormat from "utils/transformDataToDropdownFormat";
import { getAdmins } from "store/core";
import useCanAccess from "hooks/useCanAccess";
import { joinTaxonomyLabels } from "utils/contentTaxonomy";

function getStatusLabel(status) {
  const statusMap = {
    draft: "پیش نویس",
    published: "منتشر شده",
    archived: "بایگانی شده",
  };

  return statusMap[status] || "نامشخص";
}

const statusFilterOptions = [
  { value: "status-$eq-draft", label: "پیش نویس" },
  { value: "status-$eq-published", label: "منتشر شده" },
  { value: "status-$eq-archived", label: "بایگانی شده" },
];

const categoryLookupFilter = "filter[type][$eq]=News&widely=true";
const tagLookupFilter = "filter[type][$eq]=News&widely=true";
const adminLookupFilter = "";

export default function News() {
  const path = {
    baseRoute: `/news-panel`,
    aliasName: "اخبار",
    type: "News",
  };
  const {
    dispatch,
    clear,
    getList,
    list,
    load,
    create,
    update,
    quickUpdate,
    remove,
    listSearch,
    from,
    to,
    total,
  } = useList();
  const { getRoles, getCountries, getProductCategories } = useCore();
  const [showAdd, setShowAdd] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [item, setItem] = useState(false);

  const can = useCanAccess();

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        dispatch(getCategories(categoryLookupFilter));
        dispatch(getTags(tagLookupFilter));
      }
    };
    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [dispatch]);

  useEffect(() => {
    dispatch(getList(path));
    //  dispatch(getRoles());
    //  dispatch(getProductCategories());
    dispatch(getCategories(categoryLookupFilter));
    dispatch(getAdmins(adminLookupFilter));
    dispatch(getTags(tagLookupFilter));
    return () => {
      dispatch(clear());
    };
  }, []);

  const core = useCore();

  const filterItems = [
    { type: "DATE_FROM_TO" },
    {
      type: "FILTER",
      name: "filter_author",
      label: "ایجاد کننده",
      options:
        transformDataToDropdownFormat(core?.admins || [], "author-$eq") || [],
    },
    {
      type: "FILTER",
      name: "filter_categories",
      label: "دسته بندی",
      options:
        transformDataToDropdownFormat(
          core?.categories || [],
          "categories-$in"
        ) || [],
    },
    {
      type: "FILTER",
      name: "filter_tags",
      label: "تگ",
      options: transformDataToDropdownFormat(core?.tags || [], "tags-$in") || [],
    },
    {
      type: "FILTER",
      name: "filter_status",
      label: "وضعیت",
      options: statusFilterOptions,
    },
  ];

  return (
    <>
      <Add
        title="افزودن خبر"
        show={showAdd}
        close={() => {
          setShowAdd(false);
        }}
        submit={(values) => {
          dispatch(
            create(path, values, () => {
              handleSuccessMessages("خبر مورد نظر با موفقیت اضافه شد");
              dispatch(getList(path));
            })
          );
        }}
      />
      <Edit
        item={item}
        title="ویرایش خبر"
        show={showEdit}
        close={() => {
          setShowEdit(false);
        }}
        submit={(values, id) => {
          dispatch(
            update(path, id, values, () => {
              handleSuccessMessages("خبر مورد نظر با موفقیت ویرایش شد");
              dispatch(getList(path));
            })
          );
        }}
      />
      <Delete
        title="حذف خبر"
        show={showDelete}
        close={() => {
          setShowDelete(false);
        }}
        submite={() => {
          dispatch(
            remove(path, list, item?.id, () => {
              handleSuccessMessages("خبر مورد نظر با موفقیت حذف شد");
              dispatch(getList(path));
              setShowDelete(false);
            })
          );
        }}
      />

      <div className="content" style={{ marginBottom: 80 }}>
        <h2 className="intro-y text-lg font-medium mt-10">اخبار</h2>
        <div style={{ position: "relative", zIndex: 50 }}>
          <ListFilter
            path={path}
            items={filterItems}
            hasExcelReport
            style={{
              position: "absolute",
              zIndex: 99,
            }}
          />
        </div>

        <div className="grid grid-cols-12 gap-6 mt-5">
          <div className="intro-y col-span-12 flex flex-wrap gap-4 items-center mt-2 sm:justify-between">
            {can("News", "createOne") && (
              <button
                onClick={() => {
                  dispatch(getCategories(categoryLookupFilter));
                  dispatch(getTags(tagLookupFilter));
                  setShowAdd(true);
                }}
                className="btn btn-primary shadow-md w-full sm:w-56  sm:dark:text-gray-300 md:w-auto"
              >
                افزودن خبر
              </button>
            )}
            {load && (
              <div className="hidden md:block mx-auto text-gray-600">
                در حال بارگذاری
              </div>
            )}
            {!load && (
              <div className="hidden md:block mx-auto text-gray-600">
                {`نمایش ${from} تا ${to} از ${total}`}
              </div>
            )}
            <ListSearch
              search={(key) => {
                dispatch(listSearch(path, key));
              }}
            />
          </div>

          <div className="intro-y col-span-12 overflow-auto lg:overflow-visible">
            <table className="table table-report -mt-2">
              <thead>
                <tr>
                  {/* <th className="whitespace-nowrap text-center">شناسه</th> */}
                  <th className="whitespace-nowrap text-center">تصویر</th>
                  <th className="whitespace-nowrap text-center">عنوان</th>
                  <th className="whitespace-nowrap text-center">دسته</th>
                  <th className="whitespace-nowrap text-center">ایجاد کننده</th>
                  <th className="whitespace-nowrap text-center">تاریخ ثبت</th>
                  <th className="whitespace-nowrap text-center">وضعیت</th>
                  {/* <th className="whitespace-nowrap text-center">
                    تعداد بازدید
                  </th> */}
                  <th className="whitespace-nowrap text-center">عملیات</th>
                </tr>
              </thead>
              {load && <Loading />}
              {list && !list.length > 0 && (
                <h3 className="w-3/6 flex justify-center">چیزی یافت نشد</h3>
              )}
              <tbody>
                {!load &&
                  list &&
                  list.length > 0 &&
                  list.map((item, index) => (
                    <tr key={`item_${index}`} className="intro-x">
                      {/* <td className="w-16 text-center">{item.id}</td> */}
                      <td className="w-36">
                        <div className="flex justify-center">
                          <div className="w-10 h-10 image-fit zoom-in">
                            <img
                              alt=""
                              className="tooltip rounded-full"
                              src={
                                item?.media &&
                                `${process.env.REACT_APP_MEDIA_BASE_URL}${item?.media?.image?.url}`
                              }
                            />
                          </div>
                        </div>
                      </td>
                      <td>
                        <p className="font-medium whitespace-nowrap text-center">
                          {item?.translations && item?.translations?.fa?.title}
                        </p>
                      </td>
                      <td>
                        <p className="font-medium whitespace-nowrap text-center">
                          {joinTaxonomyLabels(item?.categories)}
                        </p>
                      </td>

                      <td>
                        <p className="font-medium whitespace-nowrap text-center">
                          {item?.author?.translations?.fa?.name +
                            " " +
                            item?.author?.translations?.fa?.lastName}
                        </p>
                      </td>
                      <td>
                        {" "}
                        <p className="font-medium whitespace-nowrap text-center">
                          {toJalali(
                            item?.publishedAt || item?.createdAt,
                            "jYYYY-jMM-jDD HH:mm"
                          )}{" "}
                        </p>{" "}
                      </td>
                      <td>
                        {" "}
                        <p className="font-medium whitespace-nowrap text-center">
                          {getStatusLabel(item?.status)}
                        </p>{" "}
                      </td>
                      {/* <td>
                        {" "}
                        <p className="font-medium whitespace-nowrap text-center">
                          {item?.viewCount || 0}
                        </p>{" "}
                      </td> */}
                      <td className="table-report__action">
                        <div className="flex justify-center items-center">
                          {can("News", "updateOne") && (
                            <a
                              className="flex items-center ml-3 cursor-pointer"
                              onClick={() => {
                                dispatch(
                                  getCategories(categoryLookupFilter)
                                );
                                dispatch(
                                  getTags(tagLookupFilter)
                                );
                                setItem(item);
                                setShowEdit(true);
                              }}
                            >
                              {" "}
                              <Icons.CheckSquare className="w-4 h-4 ml-1" />{" "}
                              ویرایش{" "}
                            </a>
                          )}
                          {can("News", "deleteOne") && (
                            <a
                              className="flex items-center text-theme-6 cursor-pointer"
                              onClick={() => {
                                setItem(item);
                                setShowDelete(true);
                              }}
                            >
                              <Icons.Trash2 className="w-4 h-4 ml-1" />
                              حذف{" "}
                            </a>
                          )}
                        </div>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
          <ListPagination
            getList={(page, perPage) => {
              dispatch(getList(path, page, perPage));
            }}
          />
        </div>
      </div>
    </>
  );
}
